import React from 'react'
import projectImg1 from "../assets/biametrix.png"
import projectImg2 from "../assets/project-2.png"
import projectImg3 from "../assets/aditya.png"
import Heading from '../UI/Heading'
import { Link } from 'react-router-dom'
const Projects = () => {
  return (
<>
{/* <Heading heading={"Projects"} height={"100px"}/> */}
<div className={`h-[250px] flex items-center justify-center`}>
    <div className='max-w-md mx-auto  w-full'>
    <h2 className="flex flex-row flex-nowrap items-center my-8">
        <span className="flex-grow block border-t border-[#07c991a8]" aria-hidden="true" role="presentation"></span>
        <span className={`flex-none block px-4 py-2.5  text-3xl font-semibold max-md:text-xl leading-none  uppercase text-[#07c991a8]`}>
        Projects
        </span>
        <span className="flex-grow block border-t  border-[#07c991a8]" aria-hidden="true" role="presentation"></span>
    </h2>
    </div>
    </div>
<div className=" flex justify-center items-center pb-6 ">
  <div className="md:px-4 md:grid md:grid-cols-2 lg:grid-cols-3 gap-5  md:space-y-0">
    <div className="max-w-md max-sm:mb-3 max-md:mb-3 bg-[#fff]  px-6 pt-6 pb-2 max-sm:pb-6 max-md:pb-6  rounded-xl shadow-lg transform hover:scale-105 transition duration-500">

      <div className="relative">
    <Link to={"https://biametrix.com/"} target='_blank'>
        <img className="w-full rounded h-full " src={projectImg1} alt="Colors" />
</Link>
      </div>

      
    </div>
    <div className="max-w-md max-sm:mb-3 max-md:mb-3 bg-[#fff] px-6 pt-6 pb-2 max-sm:pb-6 max-md:pb-6 rounded-xl shadow-lg transform hover:scale-105 transition duration-500">

      <div className="relative">
      <Link to={"https://products.socioloom.com"} target='_blank'>
        <img className="w-full rounded h-full" src="https://admin.socioloom.com/images/Architect.jpg" alt="Colors"/>
</Link>
      </div>

     
    </div>
    <div className="max-w-md  bg-[#fff] px-6 pt-6 pb-2 max-sm:pb-6 max-md:pb-6 rounded-xl shadow-lg transform hover:scale-105 transition duration-500">

      <div className="relative">
      <Link to={"https://adityacorporation.org/"} target='_blank'>
        <img className="w-full rounded-xl h-full" src={projectImg3} alt="Colors" />
</Link>
      </div>

     
    </div>
  </div>
</div>
</>
  )
}

export default Projects
